import script from "./TheOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./TheOrders.vue?vue&type=script&setup=true&lang=js"

import "./TheOrders.vue?vue&type=style&index=0&id=5bc38303&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc38303"]])

export default __exports__